import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCheck, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import fileManagerApi from '~/api/fileManagerApi';

function ImagePickerView({ onSelect, onCancel }) {
    const [images, setImages] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchImages();
    }, []);

    const fetchImages = async () => {
        setLoading(true);
        try {
            const response = await fileManagerApi.getAll();
            if (response && response.data) {
                setImages(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch images", error);
        } finally {
            setLoading(false);
        }
    };

    const filteredImages = images.filter(img => 
        img.FileName.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="bg-white border rounded-3 p-3 shadow-sm transition-base mb-4" style={{ borderColor: "#eaeded" }}>
            <div className="d-flex align-items-center mb-3">
                <button 
                    type="button" 
                    className="btn btn-sm btn-outline-secondary me-3"
                    onClick={onCancel}
                >
                    <FontAwesomeIcon icon={faArrowLeft} className="me-2"/> Back
                </button>
                <h5 className="mb-0 fw-bold">Select Image from Gallery</h5>
            </div>

            <div className="input-group mb-4">
                <span className="input-group-text bg-transparent border-end-0 text-muted ps-3">
                    <FontAwesomeIcon icon={faSearch} />
                </span>
                <input
                    type="text"
                    className="form-control shadow-none border-start-0"
                    placeholder="Search images..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>
            
            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <div className="files-container" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    {filteredImages.length > 0 ? (
                        filteredImages.map((file, index) => (
                            <div key={index} className="text-center">
                                <div 
                                    className="file-box-wrapper img-zoom-hover cursor-pointer" 
                                    onClick={() => {
                                        const relativeUrl = file.FileUrl ? file.FileUrl.replace(/^.*\/\/[^\/]+/, '') : file.FileUrl;
                                        onSelect(relativeUrl);
                                    }}
                                >
                                    <div className="position-relative h-100">
                                        <div className="file-box overflow-hidden">
                                            <img alt={file.FileName} className="w-100 h-100 object-fit-cover" src={file.FileUrl}/>
                                        </div>
                                        <div className="position-absolute bottom-0 start-0 mb-2 ms-2 z-1">
                                            {file.IsUsed ? (
                                                <span className="badge bg-success text-white shadow-sm fs-10"><FontAwesomeIcon icon={faCheck} className="me-1"/>In Use</span>
                                            ) : (
                                                <span className="badge bg-secondary text-white shadow-sm fs-10">Unused</span>
                                            )}
                                        </div>
                                    </div>
                                    <a className="d-block fw-bold text-body-highlight mt-2 text-nowrap text-truncate fs-9 fs-sm-9" href="#!" onClick={(e) => e.preventDefault()}>{file.FileName}</a>
                                    <h6 className="mb-0 fw-semibold text-body-tertiary fs-10 fs-sm-10">{file.SizeReadable}</h6>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="text-center py-5 text-muted">
                            No images found.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default ImagePickerView;
